export const excludeRolesByName = <T extends { name: string }>(role: T[], excludeRole: string[]) => (
  role.filter(({ name }) => !excludeRole.includes(name))
)